var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddUserIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#BDE1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 27.752V29.8414C24.8744 29.6203 24.2013 29.5 23.5 29.5C20.1863 29.5 17.5 32.1863 17.5 35.5H15.5C15.5 31.0817 19.0817 27.5 23.5 27.5C24.1906 27.5 24.8608 27.5875 25.5 27.752ZM23.5 26.5C20.185 26.5 17.5 23.815 17.5 20.5C17.5 17.185 20.185 14.5 23.5 14.5C26.815 14.5 29.5 17.185 29.5 20.5C29.5 23.815 26.815 26.5 23.5 26.5ZM23.5 24.5C25.71 24.5 27.5 22.71 27.5 20.5C27.5 18.29 25.71 16.5 23.5 16.5C21.29 16.5 19.5 18.29 19.5 20.5C19.5 22.71 21.29 24.5 23.5 24.5ZM29.5 30.5V27.5H31.5V30.5H34.5V32.5H31.5V35.5H29.5V32.5H26.5V30.5H29.5Z",
    fill: "#005DAC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUserIcon);
export default __webpack_public_path__ + "static/media/addUserIcon.d4528dd4c1c2df8a0de7ac5be997aedd.svg";
export { ForwardRef as ReactComponent };